import { Component, HostListener, inject } from "@angular/core";
import { ProgressBarComponent } from "./kernel/shared/modules/spinner/spinner.config";
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from "@angular/router";
import { Toast } from "primeng/toast";
import { NgHttpLoaderComponent, SpinnerVisibilityService } from "ng-http-loader";
import { NotificationService } from "@kernel/notifications/services/notification.service";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-root",
  imports: [Toast, RouterOutlet, NgHttpLoaderComponent, TranslateModule],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent {
  progressBar = ProgressBarComponent;

  private router = inject(Router);
  private notificationService = inject(NotificationService);

  private isNotificationRequested = false;

  @HostListener("click")
  requestNotificationPermission() {
    if (!this.isNotificationRequested && this.notificationService.getNotificationPermission() === "default") {
      this.isNotificationRequested = true;
      this.notificationService.requestToken().subscribe();
    }
  }

  constructor(private loader: SpinnerVisibilityService) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loader.show();
      }
      if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.loader.hide();
      }
    });
  }
}
